import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The AWSDateTime scalar type provided by AWS AppSync, representing a valid extended ISO 8601 DateTime
   * string of the form YYYY-MM-DDThh:mm:ss.SSSZ. The time zone offset is compulsory.
   */
  AWSDateTime: { input: any; output: any; }
};

/** A run of the full-scan state machine, which reconciles the index against what is actually in S3. */
export type IndexScan = {
  __typename?: 'IndexScan';
  /** Execution name. */
  execution: Scalars['ID']['output'];
  /**
   * Whether this run is a rebuild rather than a reconciliation.
   *
   * A reconciliation writes through the alias into the live index and ends when listing ends. A
   * rebuild targets a fresh `-v{n}`, then waits for the queue to drain and swaps the alias, so it
   * stays RUNNING long after listing has finished.
   */
  rebuild: Scalars['Boolean']['output'];
  start_date: Scalars['AWSDateTime']['output'];
  /** RUNNING | SUCCEEDED | FAILED | TIMED_OUT | ABORTED. */
  status: Scalars['String']['output'];
  /** Null while running. */
  stop_date?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IndexSearchStats = {
  __typename?: 'IndexSearchStats';
  /** Mean search wall-clock time in milliseconds, as the caller experiences it. */
  avg_duration_ms?: Maybe<Scalars['Float']['output']>;
  /**
   * `failures / requests`, in the range 0..1. Null when nothing was searched in the window.
   *
   * Counted from the search lambda's own invocations, so a client that never reached the API is not
   * represented here.
   */
  failure_rate?: Maybe<Scalars['Float']['output']>;
  /** Requests that returned an error rather than results. */
  failures: Scalars['Int']['output'];
  /** Search requests in the window. */
  requests: Scalars['Int']['output'];
  /**
   * `zero_results / requests`, in the range 0..1. Null when nothing was searched in the window.
   *
   * **The number this panel was missing.** Between 2026-09-02 and 2026-09-07 every search on prod
   * returned nothing, for four and a half days, and no other field here moved: no errors, normal
   * latency, the index current and complete. A broken authorization filter and a genuinely empty
   * result set are the same observation everywhere except this ratio.
   *
   * It is a ratio and not an alarm on purpose - some queries legitimately find nothing, and the rate
   * varies with how people search. A sustained 1.0 is the shape of a fault; a busy 0.3 is a Tuesday.
   */
  zero_result_rate?: Maybe<Scalars['Float']['output']>;
  /**
   * Searches that succeeded and returned no results.
   *
   * Counted by a metric filter on the search lambda's log group, not emitted by the handler: whenever
   * this signal matters the handler is the thing under suspicion, and a metric it publishes itself is
   * only as trustworthy as the code path being questioned.
   */
  zero_results: Scalars['Int']['output'];
};

/**
 * The state of the search index behind the content repository's file browser and search.
 *
 * Everything here is read live -- from OpenSearch, the indexing queue, and the full-scan state
 * machine -- rather than from a snapshot table. Each of those already retains its own history, and a
 * stale monitoring copy of "is the index current?" would be the one number you must not get wrong.
 */
export type IndexStats = {
  __typename?: 'IndexStats';
  /** The alias readers query, normally `files-folders`. */
  alias: Scalars['String']['output'];
  /**
   * Documents carrying `deleted: true`.
   *
   * Deletes are recorded, not removed: a deleted object stays in the index so the browser can
   * optionally show it. A count that never grows means the delete path has stopped working.
   */
  deleted?: Maybe<Scalars['Int']['output']>;
  /**
   * Messages in the three dead-letter queues, summed.
   *
   * Anything above zero is lost indexing work that needs a redrive -- documents that S3 has and the
   * index does not, and nothing will retry them on its own.
   */
  dlq_depth: Scalars['Int']['output'];
  /** Live documents in the index -- files plus folders, excluding those marked deleted. */
  documents?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Scalars['Int']['output']>;
  folders?: Maybe<Scalars['Int']['output']>;
  /**
   * The concrete versioned index the alias points at, e.g. `files-folders-v3`.
   *
   * A rebuild builds a new `-v{n}` alongside the live one and swaps the alias at the end, so this
   * changing is how you see a cutover happen.
   */
  index?: Maybe<Scalars['String']['output']>;
  /**
   * Seconds between the newest `last_modified` in the index and now.
   *
   * The headline number: this is "how far behind S3 is search". Single-digit minutes is normal for
   * the incremental path. Null if the index is empty or unreadable.
   */
  lag_seconds?: Maybe<Scalars['Int']['output']>;
  /** Messages waiting in the indexing queue. Thousands during a scan is expected; see `scan`. */
  queue_depth: Scalars['Int']['output'];
  /** Messages currently being processed by the indexer. */
  queue_in_flight: Scalars['Int']['output'];
  /**
   * Age of the oldest queued message, in seconds.
   *
   * Read together with `scan.status`: a full scan legitimately leaves hours-old messages queued,
   * and outside a scan the same number means the indexer has stalled.
   */
  queue_oldest_seconds: Scalars['Int']['output'];
  /** The most recent full scan, or null if none is retained (Step Functions keeps 90 days). */
  scan?: Maybe<IndexScan>;
  /** Search request volume and failures over the window. */
  search: IndexSearchStats;
};

export type IndexStatsInput = {
  /** Applies to `search` only. The index and queue figures are always current values. */
  window: StatsWindow;
};

/** Counts for one operation -- the `action` a process was started for, e.g. `copy_file`. */
export type ProcessActionStats = {
  __typename?: 'ProcessActionStats';
  action: Scalars['String']['output'];
  counts: ProcessCounts;
};

/**
 * Process outcome counts.
 *
 * `in_progress` is derived (`started - succeeded - failed - aborted`) rather than counted, so a process
 * that never reaches a terminal state can be neither lost nor double counted.
 *
 * Counts may drift very slightly upward: the rollup uses non-idempotent DynamoDB `ADD` against an
 * at-least-once stream, so a retried batch double counts. Do not read these to three significant
 * figures.
 */
export type ProcessCounts = {
  __typename?: 'ProcessCounts';
  /** Processes stopped deliberately, e.g. superseded by a newer process for the same item. */
  aborted: Scalars['Int']['output'];
  /** Mean wall-clock duration of the processes that finished, in milliseconds. */
  avg_duration_ms?: Maybe<Scalars['Float']['output']>;
  failed: Scalars['Int']['output'];
  /**
   * Of the processes in this window that reached a terminal state, the fraction that failed:
   * `failed / (succeeded + failed + aborted)`, in the range 0..1. Null when nothing has finished yet.
   *
   * Deliberately excludes `in_progress` from the denominator -- including still-running work would
   * make the rate drift downward during a burst and then climb as it drained, which reads as an
   * incident that is not happening. Watch `in_progress` alongside it.
   */
  failure_rate?: Maybe<Scalars['Float']['output']>;
  /** Started but not yet in a terminal state. */
  in_progress: Scalars['Int']['output'];
  /**
   * Processes still `IN_PROGRESS` in an hour bucket old enough that they cannot plausibly still be
   * running.
   *
   * This is not only slow work. The repository API has no EventBridge rule reflecting an aborted
   * Step Functions execution back into its process table (the workflow API does, via
   * `reflect_abort_in_dynamodb`), so an aborted repository process stays `IN_PROGRESS` in the ledger
   * forever. Treat a persistently non-zero value here as a data-quality signal, not as a backlog.
   */
  stale_in_progress: Scalars['Int']['output'];
  /** Processes whose start date falls in the window. */
  started: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

export type ProcessFailure = {
  __typename?: 'ProcessFailure';
  action: Scalars['String']['output'];
  end_date?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The error the process recorded, e.g. the caught Step Functions error name. */
  message?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['AWSDateTime']['output'];
};

export type ProcessFailurePage = {
  __typename?: 'ProcessFailurePage';
  /** Most recent first. */
  failures: Array<ProcessFailure>;
  /** Pass back as `next_token` to continue. Null when the window is exhausted. */
  next_token?: Maybe<Scalars['String']['output']>;
};

export type ProcessFailuresInput = {
  /** Restrict to one operation, for the drill-down from `by_action`. */
  action?: InputMaybe<Scalars['String']['input']>;
  api: StatsApi;
  /** Defaults to 50, capped at 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  next_token?: InputMaybe<Scalars['String']['input']>;
  window: StatsWindow;
};

export type ProcessStats = {
  __typename?: 'ProcessStats';
  api: StatsApi;
  /** Per-operation breakdown, most failures first, for the drill-down. */
  by_action: Array<ProcessActionStats>;
  totals: ProcessCounts;
  window: StatsWindow;
  window_end: Scalars['AWSDateTime']['output'];
  window_start: Scalars['AWSDateTime']['output'];
};

export type ProcessStatsInput = {
  api: StatsApi;
  /** Hours after which a still-running process is reported in `stale_in_progress`. Defaults to 24. */
  stale_after_hours?: InputMaybe<Scalars['Int']['input']>;
  window: StatsWindow;
};

/** A failed execution of a publication method's state machine. */
export type PublishFailure = {
  __typename?: 'PublishFailure';
  end_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** The execution name, usable to find it in the Step Functions console. */
  execution: Scalars['ID']['output'];
  start_date: Scalars['AWSDateTime']['output'];
  state_machine: Scalars['String']['output'];
};

export type PublishFailurePage = {
  __typename?: 'PublishFailurePage';
  /** Most recent first. */
  failures: Array<PublishFailure>;
  /** Pass back as `next_token` to continue. Null when the window is exhausted. */
  next_token?: Maybe<Scalars['String']['output']>;
};

export type PublishFailuresInput = {
  /** Defaults to 50, capped at 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  next_token?: InputMaybe<Scalars['String']['input']>;
  /** The `state_machine` from `PublishMethodStats`, for the drill-down. */
  state_machine: Scalars['String']['input'];
  window: StatsWindow;
};

/**
 * Execution counts for one publication method's state machine, from `AWS/States` metrics.
 *
 * Trustworthy here, unlike for the process APIs: every publish-method state machine catches an error
 * into `handle_error` and then enters a real `Fail` state, so `ExecutionsFailed` counts exactly the
 * publishes that failed. Timed-out executions are folded into `failed` -- a publish that timed out did
 * not deliver.
 */
export type PublishMethodStats = {
  __typename?: 'PublishMethodStats';
  aborted: Scalars['Int']['output'];
  /** Mean execution wall-clock time of finished executions, in milliseconds. */
  avg_duration_ms?: Maybe<Scalars['Float']['output']>;
  /** Failed plus timed-out executions. */
  failed: Scalars['Int']['output'];
  /**
   * `failed / (succeeded + failed + aborted)`, in the range 0..1. Null when nothing has finished in
   * the window. Same denominator convention as `ProcessCounts.failure_rate`.
   */
  failure_rate?: Maybe<Scalars['Float']['output']>;
  /** Started but not yet in a terminal state, derived as `started - succeeded - failed - aborted`. */
  in_progress: Scalars['Int']['output'];
  /**
   * The method as configured, with the `publish-` prefix and environment/step suffix stripped,
   * e.g. `aspera-anuvu`, `dropbox-lambda`, `thales-medianet`.
   */
  method: Scalars['String']['output'];
  /** Executions started in the window. Each execution is one file/batch publish. */
  started: Scalars['Int']['output'];
  /** The state machine name, e.g. `publish-aspera-anuvu-prod-copy`. The stable identifier. */
  state_machine: Scalars['String']['output'];
  succeeded: Scalars['Int']['output'];
};

/**
 * All configured publication methods, autodiscovered.
 *
 * Discovered at query time by listing Step Functions state machines named `publish-*` for this
 * environment -- deploying a new publish stack makes it appear here without any monitoring change.
 * The publish-PO orchestrator is excluded by that same convention (its machines are named
 * `Workflow-Publish-...`).
 */
export type PublishStats = {
  __typename?: 'PublishStats';
  /** One entry per discovered state machine, most failures first. */
  methods: Array<PublishMethodStats>;
  window: StatsWindow;
  window_end: Scalars['AWSDateTime']['output'];
  window_start: Scalars['AWSDateTime']['output'];
};

export type PublishStatsInput = {
  window: StatsWindow;
};

export type Query = {
  __typename?: 'Query';
  /**
   * The search index: how far behind S3 it is, what is queued, the last full scan, and whether
   * search itself is answering.
   *
   * Read live from OpenSearch, SQS and Step Functions at resolve time. Global like the rest of this
   * API -- authorization gates the field, not the rows.
   */
  index_stats: IndexStats;
  /** The individual failed processes behind `process_stats`, for drill-down. */
  process_failures: ProcessFailurePage;
  /**
   * Process volume and failure rate for one API over a window, with a per-operation breakdown.
   *
   * Aggregated from the process table, never from `AWS/States` metrics: the process state machine
   * catches a failed action, records `state=FAILED` on the row, and then completes successfully, so
   * `ExecutionsFailed` reports approximately zero for exactly the failures that destroy a caller's
   * work.
   *
   * This is a global view -- it aggregates every organization's processes. Authorization gates the
   * field, not the rows.
   */
  process_stats: ProcessStats;
  /** The individual failed publish executions behind `publish_stats`, for drill-down. */
  publish_failures: PublishFailurePage;
  /**
   * Execution stats for every configured publication method, autodiscovered from the deployed
   * `publish-*` state machines. Global like the process stats -- authorization gates the field.
   */
  publish_stats: PublishStats;
  /** VTK jobs across all organizations, grouped by status, with a per-organization breakdown. */
  vtk_job_stats: VtkJobStats;
};


export type QueryIndex_StatsArgs = {
  input: IndexStatsInput;
};


export type QueryProcess_FailuresArgs = {
  input: ProcessFailuresInput;
};


export type QueryProcess_StatsArgs = {
  input: ProcessStatsInput;
};


export type QueryPublish_FailuresArgs = {
  input: PublishFailuresInput;
};


export type QueryPublish_StatsArgs = {
  input: PublishStatsInput;
};


export type QueryVtk_Job_StatsArgs = {
  input: VtkJobStatsInput;
};

/**
 * Which API's processes to report on. The two process tables are separate ledgers with disjoint sets
 * of operations, so they are never summed together.
 */
export enum StatsApi {
  Repository = 'REPOSITORY',
  Workflow = 'WORKFLOW'
}

/**
 * The reporting window, always ending now.
 *
 * Counters are stored per (day, hour), so a window is expanded into the hour buckets it covers and
 * those are read directly -- HOURS_24 is two Queries and DAYS_7 is eight.
 */
export enum StatsWindow {
  Days_7 = 'DAYS_7',
  Hours_24 = 'HOURS_24',
  Hour_1 = 'HOUR_1'
}

/**
 * VTK jobs across every organization, from a snapshot collected on a schedule rather than live.
 *
 * A per-organization API cannot be fanned out from the browser: a Content Platform admin holds no VTK
 * role in most airline organizations, so the picture would be silently partial. A collector using the
 * platform's own credentials walks every known organization instead.
 *
 * Jobs stop being refreshed once they age out of the collector's 24h window, so their status freezes
 * at last-seen. That is correct for a terminal status and stale for a job that was still running --
 * `DAYS_7` is therefore honest about volume but approximate about live status.
 */
export type VtkJobStats = {
  __typename?: 'VtkJobStats';
  /** Per-organization breakdown, busiest first, for the drill-down. */
  by_organization: Array<VtkOrgStats>;
  by_status: Array<VtkStatusCount>;
  /** When the collector last completed a pass. Null if it has never run. */
  collected_at?: Maybe<Scalars['AWSDateTime']['output']>;
  total: Scalars['Int']['output'];
  window_end: Scalars['AWSDateTime']['output'];
  window_start: Scalars['AWSDateTime']['output'];
};

export type VtkJobStatsInput = {
  /** Restrict to one organization, for the drill-down from `by_organization`. */
  organization_urn?: InputMaybe<Scalars['String']['input']>;
  window: StatsWindow;
};

export type VtkOrgStats = {
  __typename?: 'VtkOrgStats';
  by_status: Array<VtkStatusCount>;
  organization_urn: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/**
 * A VTK job status, as VTK numbers them: 0 submitted, 1 in progress, 2 completed, 3 failed,
 * 4 aborted, 5 waiting, 6 terminated.
 */
export type VtkStatusCount = {
  __typename?: 'VtkStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  status_text: Scalars['String']['output'];
};
